
$(function () {

    $("#country").change(function () {

        var getCountry = $(this).val();

        if (getCountry != '') {
            $.ajax({
                type: 'GET',
                url: '/ajaxCitiesFromCountryId',
                data: { country: getCountry },
                success: function (data) {
                    $('#city').empty().append(data.msg);
                }
            });
        }
        else {
            $("#city").empty('');
        }
    });

});

function loadSearchFilters(){   
    var getType = $('#project_type').val();
    var getSession = $('#sess').val();
    
    if (getType != '') {
        $.ajax({
            type: 'POST',
            url: '/ajaxGetSearchFilters',
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            data: { projectType: getType,
                    sessionStr: getSession,
                 },
            success: function (data) {
                $('#filters').empty().append(data.msg);
                $('.js-example-basic-multiple').select2();
            }
        });
    }
    else {
        $("#filters").empty('');
    }
   
}

$(function () {
    if ($('#project_type').val())
        loadSearchFilters();
    $("#project_type").change(loadSearchFilters);
    $('.js-example-basic-multiple').select2();
    
});